import { formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns'

export default function timeAgo(dt, strict = false) {
	if (strict) return formatDistanceToNowStrict(dt)
	return formatDistanceToNow(dt)
}
